import { Component, Inject, OnInit } from '@angular/core';
import { UserAdminServiceData } from '../user-admin.model';
import { UserAdminService } from '../user-admin.service';

@Component({
    selector: 'cv-selected-user-label',
    templateUrl: './selected-user-label.component.html',
    styleUrls: ['./selected-user-label.component.scss']
})
export class SelectedUserLabelComponent implements OnInit {
    private uas: UserAdminServiceData;

    constructor(
        private userAdminService: UserAdminService
    ) {
        this.uas = userAdminService.dataObj;
    }

    ngOnInit(): void {
    }

    formattedName(): string {
        return (this.uas.selectedUserName == '') ? '' : ' - ' + this.uas.selectedUserName;
    }
}
